import React, { type FC } from "react"
import RightIcon from "@icons/RightIcon"
import { Container } from "@components/styles"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import type { PositionsProps } from "./types"
import {
    PositionWrapper,
    Position,
    StyledImage,
    Info,
    Title,
    JobFunction,
    ButtonWrapper,
    StyledButton
} from "./styles"

const Positions: FC<PositionsProps> = ({
    positions
}) => {
    return <Container>
        <PositionWrapper>
            {positions && positions.map((p) => {
                return (
                    <Position key={p.id}>
                        <StyledImage>
                            <GatsbyImage
                                image={getImage(p.image?.file)}
                                alt={p.image?.alternativeText}
                            />
                        </StyledImage>
                        <Info>
                            <Title>{p.name}</Title>
                            <JobFunction>{p.function}</JobFunction>
                            {p.linkedin_url && <ButtonWrapper>
                                <StyledButton
                                    isRound
                                    href={p.linkedin_url}
                                >
                                    <RightIcon />
                                </StyledButton>
                            </ButtonWrapper>}
                        </Info>
                    </Position>
                )
            })}
        </PositionWrapper>
    </Container>
}

export default Positions
